import { createStaticReducer } from '../../../../packages/redux-utils';
import { TLayoutType } from '../../types/layoutType';

const defaultState: TLayoutType = 'default';

export const layoutTypeReducer = createStaticReducer<TLayoutType>(defaultState);
